export const partnersConfig = [
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/epfo.png',
    imgWebp: 'https://media.umangapp.in/cdn/landing/theme/partners/epfo.webp',
    alt: 'epfo',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/apy.png',
    imgWebp: 'https://media.umangapp.in/cdn/landing/theme/partners/apy.webp',
    alt: 'apy',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/arogya-setu.png',
    imgWebp:
      'https://media.umangapp.in/cdn/landing/theme/partners/arogya-setu.webp',
    alt: 'arogya-setu',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/bharat-gas.png',
    imgWebp:
      'https://media.umangapp.in/cdn/landing/theme/partners/bharat-gas.webp',
    alt: 'bharat-gas',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/digilocker.png',
    imgWebp:
      'https://media.umangapp.in/cdn/landing/theme/partners/digilocker.webp',
    alt: 'digilocker',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/eraktKos.png',
    imgWebp:
      'https://media.umangapp.in/cdn/landing/theme/partners/eraktKos.webp',
    alt: 'eraktKos',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/esic.png',
    imgWebp: 'https://media.umangapp.in/cdn/landing/theme/partners/esic.webp',
    alt: 'esic',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/hp-gas.png',
    imgWebp: 'https://media.umangapp.in/cdn/landing/theme/partners/hp-gas.webp',
    alt: 'hp-gas',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/indian-oil.png',
    imgWebp:
      'https://media.umangapp.in/cdn/landing/theme/partners/indian-oil.webp',
    alt: 'indian-oil',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/jan-aushadhi.png',
    imgWebp:
      'https://media.umangapp.in/cdn/landing/theme/partners/jan-aushadhi.webp',
    alt: 'jan-aushadhi',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/jeevan-praman.png',
    imgWebp:
      'https://media.umangapp.in/cdn/landing/theme/partners/jeevan-praman.webp',
    alt: 'jeevan-praman',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/mypan.png',
    imgWebp: 'https://media.umangapp.in/cdn/landing/theme/partners/mypan.webp',
    alt: 'mypan',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/national-health-mission.png',
    imgWebp:
      'https://media.umangapp.in/cdn/landing/theme/partners/national-health-mission.webp',
    alt: 'national-health-mission',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/nppa.png',
    imgWebp: 'https://media.umangapp.in/cdn/landing/theme/partners/nppa.webp',
    alt: 'nppa',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/nps.png',
    imgWebp: 'https://media.umangapp.in/cdn/landing/theme/partners/nps.webp',
    alt: 'nps',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/pmay.png',
    imgWebp: 'https://media.umangapp.in/cdn/landing/theme/partners/pmay.webp',
    alt: 'pmay',
  },
  {
    img: 'https://media.umangapp.in/cdn/landing/theme/partners/ssc.png',
    imgWebp: 'https://media.umangapp.in/cdn/landing/theme/partners/ssc.webp',
    alt: 'ssc',
  },
];
